module.exports = __webpack_public_path__ + "static/media/kp.d8a241bf.jpg";